import React from 'react';
import { Typography } from '@material-ui/core';

import styles from './PlayText.module.scss';

const PlayText = ({ play }) => (
  <div className={styles.playText}>
    <div
      className={styles.logo}
      style={play.team ? { backgroundImage: `url(${play.team})` } : undefined}
    />

    <Typography className={styles.text} variant="body2">
      {play.description}
    </Typography>
  </div>
);

export default PlayText;
